export default "__VITE_ASSET__BpCRl4Ah__"